import { GLOBAL_NAV_HEIGHT } from './enums';

const isAtTop = () => window.pageYOffset <= GLOBAL_NAV_HEIGHT;

const getScrollListener = handler => () => {
  const listenerArgs = ['scroll', () => handler(isAtTop())];
  window.addEventListener(...listenerArgs);
  return () => window.removeEventListener(...listenerArgs);
};

export default getScrollListener;
